import { ApolloClient, createHttpLink, InMemoryCache, gql } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_URL_GRAPH,
});

const authLink = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        'X-API-KEY': process.env.REACT_APP_APIKEY_GRAPH,
      },
    }
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
});

export const sendINE = async (inefrontal, inereversa) => {

    /// query Nobarium
    const queryNubarium = gql`
    query QNubarium {
        getIdDataNubarium(input: {id: "${inefrontal}", idReverso: "${inereversa}"}) {
            code
            message
            result {
              calle
              ciudad
              claveElector
              codigoBarras
              codigoValidacion
              curp
              colonia
              edad
              emision
              estado
              folio
              localidad
              municipio
              nombres
              ocr
              primerApellido
              registro
              seccion
              segundoApellido
              sexo
              subTipo
              tipo
              vigencia
              fechaNacimiento
              mrz
              identificadorCiudadano
              validacionMRZ {
                emision
                fechaNacimiento
                nombre
                sexo
                vigencia
              }
              cic
            }
        }
    }`;

    try{

      const response = await  client.query({
        query: queryNubarium
      });

      if(response.data.getIdDataNubarium.code === 200){
        var datageneral = response.data.getIdDataNubarium.result;
        return dataInformation(datageneral);

      }else{
        return dataInformation("error");
      }
      
  
    }catch (error) {
      return dataInformation("error");
    }

}

export const sendComp = async (comprobante, uiid) => {

    /// Qury Nobarium
    const queryNumariumComprobante = gql`
    query QNubariumComp {
        getProofOfAddressNubarium(input: {comprobante: "${comprobante}", uuid: "${uiid}"}) {
            code
            message
            result {
              QR
              calle
              ciudad
              claveMensaje
              codigoValidacion
              colonia
              cp
              fecha
              mesFacturacion
              mesFacturacion2
              nombre
              numeroFactura
              numeroServicio
              pagarAntesDe
              pagarAntesDe2
              periodoFacturado
              referencia
              rmu
              status
              tarifa
              telefono
              telefono2
              totalPagar
              totalPagar2
            }
        }
    }`;

    try{

      const response = await  client.query({
        query: queryNumariumComprobante
      });

      if(response.data.getProofOfAddressNubarium.code === 200 || response.data.getProofOfAddressNubarium.code === 409){
        
        if(response.data.getProofOfAddressNubarium.code === 200){
          var datadomicilio = response.data.getProofOfAddressNubarium.result;
          return dataInformation(datadomicilio);
        }else{
          return dataInformation({calle: null, ciudad: null, colonia: null});
        }
      }else{
        return dataInformation("error");
      }
  
  
    }catch (error) {
      
      return dataInformation("error");
    }

}

export const sendCURP = async (curp) => {

  /// Qury Nobarium
  const queryNumariumCURP = gql`
    query CURPNubarium {
      validateCurpNubarium(input: {curp: "${curp}", documento: "0"}) {
        code
        message
        result {
          apellidoMaterno
          apellidoPaterno
          codigoMensaje
          codigoValidacion
          curp
          docProbatorio
          estadoNacimiento
          estatus
          estatusCurp
          fechaNacimiento
          nombre
          paisNacimiento
          sexo
        }
      }
    }`;

    try{

    const response = await  client.query({
      query: queryNumariumCURP
    });

    if(response.data.validateCurpNubarium.code === 200){
      var dataCURP = response.data.validateCurpNubarium.result;
      return dataInformation(dataCURP);

    }else{
      return dataInformation("error");
    }


  }catch (error) {
    return dataInformation("error");
  }

}
 
export const getInformation = async (curp) => {

   /// query to get photograps
   const queryInformation = gql`
    query MyQuery {
      getInformationByCurp(input: {curp: "${curp}"}) {
        code
        message
        result {
          anioReg
          apellidoMaterno
          apellidoPaterno
          cveEntidadNac
          cveMunicipioReg
          fechNac
          genero
          nacionalidad
          nombre
        }
      }
    }
    `;

    try{

      const response = await  client.query({
        query: queryInformation
      });

      let responseInformation   = response.data.getInformationByCurp;

      return dataInformation(responseInformation);
      

    }catch (error) {

      return dataInformation("error_information");

    }

}

export const validateVigenceINE = async (body) => {

  /// query to validate INE
  const queryVigenceINE = gql`
    query MyQuery {
      validateINENubarium(input: ${body}) {
        result {
          anioEmision
          anioRegistro
          cic
          claveMensaje
          claveElector
          codigoValidacion
          mensaje
          informacionAdicional
          estatus
          numeroEmision
          ocr
          vigencia
        }
        message
        code
      }
    }`;

  try{

    const response = await  client.query({
      query: queryVigenceINE
    });

    let responseVINE   = response.data.validateINENubarium;

    return dataInformation(responseVINE);

  }catch (error) {

    return dataInformation("error_service");

  }

}

export const originationValidatePhone = async (phone) => {

  /// query to validate phone
  const queryValidatePhone = gql`
    query ValidatePhone {
      validatePhoneNumber(input: {legacy: true, phoneNumber: "${phone}"}) {
        code
        message
      }
    } `;

  try{

    const response = await  client.query({
      query: queryValidatePhone
    });

    let responsePhone   = response.data.validatePhoneNumber;

    return dataInformation(responsePhone);

  }catch (error) {
    return dataInformation("error_service");

  }

}

export const originationValidatePhoneM = async (phoneCell, phoneHome, uuid) => {

  var query1 = "";
  var query2 = "";

  if(phoneCell){
    query1 = `phoneCell: validatePhoneNumber(input: {legacy: true, phoneNumber: "${phoneCell}", uuid: "${uuid}" }) {
      code
      message
    }`;
  }

  if(phoneHome){
    query2 = `phoneHome: validatePhoneNumber(input: {legacy: true, phoneNumber: "${phoneHome}", uuid: "${uuid}" }) {
      code
      message
    }`;
  }

  /// query to validate phone
  const queryValidatePhone = gql`
    query ValidatePhone {
      ${query1}
      ${query2}
    }`;

  try{

    const response = await  client.query({
      query: queryValidatePhone
    });

    const arrayresponse = {};

    if(query1 != ""){
      arrayresponse['phoneCell'] = {
        "code":    response.data.phoneCell.code,
        "message": response.data.phoneCell.message,
      }
    }else{
      arrayresponse['phoneCell'] = {
        "code":    200,
        "message": "NOT FOUND",
      }
    }

    if(query2 != ""){
      arrayresponse['phoneHome'] = {
        "code":    response.data.phoneHome.code,
        "message": response.data.phoneHome.message,
      }
    }else{
      arrayresponse['phoneHome'] = {
        "code":    200,
        "message": "NOT FOUND",
      }
    }

    return dataInformation(arrayresponse);

  }catch (error) {
    return dataInformation("error_service");
  }

}

export const originarionValidateCURP = async (curp) => {

  /// query to validate phone
  const queryValidateCURP = gql`
    query ValidateCURP {
      validOriginationRules(input: {enumBusinessKey: regla_origen, expression: "${curp}", legacy: true}) {
        code
        message
        result {
          description
          mandatory
          ruleResult
        }
      }
    }
    `;

  try{

    const response = await  client.query({
      query: queryValidateCURP
    });

    //let responsePhone   = response.data.validatePhoneNumber;

    //return dataInformation(responsePhone);

  }catch (error) {

    //return dataInformation("error_service");

  }

}

export const originationValidateBlack = async (curp) => {

  /// query to validate phone
  const queryValidateBackList = gql`
    query validateBackLis {
      validBlackList(input: {idRolBusinessKeyPrimary: "TUCG891212HPLRMD09", legacy: true}) {
        code
        message
        result
      }
    }`;

  try{

    const response = await  client.query({
      query: queryValidateBackList
      //fetchPolicy:  "no-cache"
    });

    let responseBlackList   = response.data.validBlackList;

    return dataInformation(responseBlackList);

  }catch (error) {

    return dataInformation("error_service");

  }

}

export const originationValidations = async (body, curp) => {
  
  /// query validate ine vigence, back List
  const queryValidationsOrigin = gql`
   query validationsOrigin {
      ineVigence: validateINENubarium(input: ${body}) {
          result {
            anioEmision
            anioRegistro
            cic
            claveMensaje
            claveElector
            codigoValidacion
            mensaje
            informacionAdicional
            estatus
            numeroEmision
            ocr
            vigencia
          }
          message
          code
      }
      blackList: validBlackList(input: {idRolBusinessKeyPrimary: "${curp}", legacy: true}) {
          code
          message
          result
      }
      rulescurp: validOriginationRules(input: {enumBusinessKey: regla_origen, expression: "${curp}", legacy: true}) {
          code
          message
          result {
            description
            mandatory
            ruleResult
          }
      }
      
    }`;

    try{

      const response = await  client.query({
        query: queryValidationsOrigin
      });

      var responseService = response.data;
  
      return dataInformation(responseService);

  }catch (error) {
    return dataInformation("error_service");

  }

}

export const consultByCodePostal = async (codePostal) => {

  /// query validate code postal
  const queryValidationsCodePostal = gql`
    query validationsOrigin {
      getZipCode(input: {cp: "${codePostal}"}) {
        code
        message
        result {
          ciudad
          cp
          estado
          municipio
          asentamiento
          pais
        }
      }
    }`;

    try{

      const response = await  client.query({
        query: queryValidationsCodePostal
      });

      if(response.data.getZipCode.code === 200){
        var dataCodePostal = response.data.getZipCode.result;
        return dataInformation(dataCodePostal);
      }else{
        return dataInformation("error");
      }

    }catch (error) {
      return dataInformation("error");
    }

}

export const consultStates = async (codePostal) => {
  const queryStates = gql`
    query catStates {
      getStates(cp: "${codePostal}") {
        code
        message
        response
      }
    }`

  try {
    const response = await client.query({
      query: queryStates
    });

    let arrayStates = [];
    
    if(response.data.getStates.code === 200){

      let dataResponse = response.data.getStates.response;

      for(let i=0; i < dataResponse.length; i++){
        arrayStates.push({
          value: dataResponse[i],
          label: dataResponse[i],
        });
      }

      return dataInformation(arrayStates);

    }else{
      return dataInformation("error");
    }
    
  } catch (error) {
    return dataInformation("error");
  }
}

///
export const getUID = async (schema) => {
  /// query to get uiid
  const queryUUID = gql`
    query UUID {
      getUuid(input: {idActSchema: "${schema}", origin: web}) {
        code
        message
        result
      }
    }`

  try {
    const response = await client.query({
      query: queryUUID
    })

    if(response.data.getUuid.code === 200){
      return responseUUID(response.data.getUuid.result)
    }else{
      return responseUUID('error')    
    }

  } catch (error) {
    return responseUUID('error')
  }
}

const responseUUID = (dataUUID) => {
  return dataUUID
}

export const getFiles = async (uuid, creditoid) => {

  /// Query get Files
  const queryGetFiles = gql`
      query getFiles {
          consultFiles(uuid: "${uuid}", idCredit: 0) {
              code
              message
              response {
                curp
                comprobante
                ineAnverso
                ineReverso
                infoCurp
                selfie
                vigence
                isIneAdress
              }
          }
      }`;
  
  try{

      const response = await  client.query({
          query: queryGetFiles
      });

      return dataInformation(response.data.consultFiles)
      
  }catch (error) {

      return dataInformation("error");
  }
}

export const calculateActos = async (uuid) => {

  /// Query Calculate Actos
  const queryCalculateActos= gql`
  query CalculateActos {
      calculateInformation(uuid: "${uuid}") {
        code
        message
        response {
          actAdress
          actContact
          actGeneralData
          actCurp
          actProofOfAddress
          actSelfie
          actIneObverse
          actIneReverse
          vigence
        }
      }
    }`;

  try{

      const response = await  client.query({
          query: queryCalculateActos
      });

      let responseCalculate = response.data.calculateInformation;

      return dataInformation(responseCalculate);

  }catch (error) {
      return dataInformation("error");
  }

}

export const consultPersonalInf = async (uiid) => {

  /// Query Get Personal Info
  const queryPersonalInf = gql`
    query PersonalInoformation {
      getPersonalInfo(uuid: "${uiid}") {
        code
        message
        response {
          personalInfo {
            apellidoM
            apellidoP
            ciudadNac
            curp
            estadoCivil
            estadoNac
            fechaN
            genero
            nacionalidad
            nombre
            paisNac
            rfc
            numeroINE
            claveElector
          }
          adressInfo {
            calle
            ciudad
            codigoPostal
            colonia
            estado
            municipio
            numExterior
            numInterno
            pais
          }
          contactInfo {
            correo
            telefonoCasa
            telefonoCelular
          }
        }
      }
    }`;

  try{

    const response = await  client.query({
      query: queryPersonalInf
    });

    let responsePInformation = response.data.getPersonalInfo;

    return dataInformation(responsePInformation);

  }catch (error) {
    return dataInformation("error");
  }

}

export const consultAdvanceFlow = async (uuid) => {

  /// Query Get Flows
  const queryGetFlows = gql`
    query getFlows {
      getAdvanceFlow(uuid: "${uuid}") {
        code
        message
        response {
          businessKey
          clientUuid
          statusM
          target
          flow1 {
            ageMaximum
            ageMinimum
            blackList
            existsProspect
            formatCurp
            gender
            ineVigence
            longCurp
            nubariumIFEs
            takeFoto
            takeTFoto
          }
          flow2 {
            isFace
          }
          flow3 {
            isAddress
            isIneAdress
          }
        }
      }
  }`;

  try{

    const response = await  client.query({
      query: queryGetFlows
    });

    let responseGFlows = response.data.getAdvanceFlow;

    return dataInformation(responseGFlows);

  }catch (error) {
    return dataInformation("error");
  }

}

export const consultInformationC = async (uuid, creditid) => {
  
  /// Query get all information
  const queryGetInformationc = gql`
      query getInformationc {
          filesd: consultFiles(uuid: "${uuid}", idCredit: 0) {
              code
              message
              response {
                curp
                comprobante
                ineAnverso
                ineReverso
                infoCurp
                selfie
                vigence
              }
          }
          infd:getPersonalInfo(uuid: "${uuid}") {
            code
            message
            response {
              personalInfo {
                apellidoM
                apellidoP
                ciudadNac
                curp
                estadoCivil
                estadoNac
                fechaN
                genero
                nacionalidad
                nombre
                paisNac
                rfc
                numeroINE
                claveElector
              }
              adressInfo {
                calle
                ciudad
                codigoPostal
                colonia
                estado
                municipio
                numExterior
                numInterno
                pais
              }
              contactInfo {
                correo
                telefonoCasa
                telefonoCelular
              }
            }
          }
        }`;
  
  try{

    const response = await  client.query({
      query: queryGetInformationc
    });

    let responseData = response.data;

    return dataInformation(responseData);
    
  }catch (error) {
    return dataInformation("error");
  }

}

const dataInformation = (datac) => {
  return datac;
} 
